import { MenuItem } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import { ensureDefaultAttribute } from '../../common/utils/Attributes';
// For NavigationRail internal use only
// Click event is stopped because the popover take care of binding the proper events.
export class InternalNavigationRailItemComponent extends ChameleonElementMixin(MenuItem) {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            e.stopImmediatePropagation();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'appearance', 'navrailitem');
        this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.handleClick);
    }
}
